import "../../internal/features/stages/middleware.js";
import "../../internal/features/stages/reducer.js";
import { selectAll, selectLoading, selectError, selectService } from "../../internal/features/stages/selectors.js";
import { useAppActions } from "../../internal/shared/lib/store/hooks/useAppActions.js";
import { useAppSelector } from "../../internal/shared/lib/store/hooks/useAppSelector.js";
function useStages() {
  const {
    stages: { getStages }
  } = useAppActions();
  const stages = useAppSelector(selectAll);
  const loading = useAppSelector(selectLoading);
  const error = useAppSelector(selectError);
  const service = useAppSelector(selectService);
  return {
    data: stages,
    service,
    loading,
    error,
    actions: {
      getStages
    }
  };
}
export {
  useStages
};
